import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-consignment',
  templateUrl: './home-consignment.component.html',
  styleUrls: ['./home-consignment.component.css']
})
export class HomeConsignmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/consignment/components/home-consignment/home-consignment.component.ts